import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-historical-trends-upgrade',
    templateUrl: './historical-trends-upgrade.component.html',
    styleUrls: ['./historical-trends-upgrade.component.scss'],
})
export class HistoricalTrendsUpgradeComponent implements OnInit {
    headline: string;
    shortOverview: string;
    selligPointHeader: string;
    logoPlaceholder: string;
    moduleShortDescription: string;
    backgroundColor: string;

    constructor() {}
    ngOnInit() {
        this.setUpgradePage();
    }

    setUpgradePage() {
        this.headline = 'Know where you’ve been so you know where to go';
        this.shortOverview =
            'Are your applications ticking up or down? What about compared to last year or the last 4 years?';
        this.selligPointHeader = 'Analyze Apps, Credit, Locks, Funding’s Year-over-Year';
        this.logoPlaceholder = 'src/assets/images/upgrade_thumbnails/historical_upgrade.png';
        this.moduleShortDescription =
            'Historical view of leading indicator activity all combined in simple, interactive, and appealing visualizations.  See how events have affected your applications, leads, and volume over the last 5 years.';
        this.backgroundColor = '#f3e7ff';
    }
}
